import React, { useEffect } from "react";
import "../styles/CustomModal.scss";
import promoImage from "../images/fondo.png";

const CustomModal = ({ show, onClose }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    if (show) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div className="custom-modal-overlay">
      <div
        className="custom-modal-content"
        onClick={onClose} // ✅ clic en cualquier parte del modal lo cierra
      >
        <button className="custom-close-button" onClick={onClose}>
          ✕
        </button>
        <img src={promoImage} alt="Promoción" className="modal-image" />
      </div>
    </div>
  );
};


export default CustomModal;
